import { Pipe, PipeTransform } from '@angular/core';
import { BENEFIT_NAME } from '@app/config/benefit-name.enum';

@Pipe({
  name: 'benefitIndex'
})
export class BenefitIndexPipe implements PipeTransform {

  public dataSelectBenefits = BENEFIT_NAME.map(b => { return b });

  transform(value: any): number {

    return this.dataSelectBenefits.findIndex(x => x.id === value);
  }

}
